import type { CSSProperties } from 'react'
import type { SignalColor } from '@indipia/shared'
import type { StageBarTone } from '@indipia/ui-core'
import type { ScheduleListCells, StageCell } from '../../types/scheduleList.types'
import { LANE_NO_SIGNAL_TEXT, LANE_UNKNOWN_TEXT } from '../../constants/scheduleListStage.logic'

// 리스트 보기 컴포넌트 공용 표시 보조 — 색 토큰 대응·칸 상태 글자. 판정은 하지 않고 로직 파일이 준 값을 글자·토큰으로 옮기기만 한다.

/** 신호 색 → 글자색 토큰(점과 같은 의미색, 흰색·해당 없음은 보조 글자색) */
export const SIGNAL_TEXT_COLOR: Record<SignalColor, string> = {
  RED: 'var(--status-danger-600)',
  YELLOW: 'var(--status-warning-700)',
  GREEN: 'var(--status-success-600)',
  BLUE: 'var(--status-info-600)',
  WHITE: 'var(--shell-on-surface-2)',
  NONE: 'var(--shell-hint)',
}

/** 신호 색 → 단계 막대의 '지금 칸' 색(빨강·노랑만 색을 쓰고 나머지는 기본 회색) */
export function stageTone(color: SignalColor): StageBarTone {
  if (color === 'RED') return 'danger'
  if (color === 'YELLOW') return 'warning'
  return 'default'
}

/** 칸 표시 문구(발주 칸 부분 오류 포함) */
export const LIST_ORDER_NONE_TEXT = '발주 없음'
export const LIST_FOREMAN_NONE_TEXT = '자재파트너 시공'
export const LIST_SCHEDULE_ONLY_TEXT = '해당 없음'
export const LIST_ORDER_ERROR_TEXT = '발주 정보를 불러오지 못했어요'

export const DIM_TEXT_STYLE: CSSProperties = { color: 'var(--shell-hint)', fontSize: 'var(--type-caption-size)' }

/** 칸 1개의 상태 글자 — 점 title·선행공종 줄에 쓴다 */
export function cellStatusText(cell: StageCell | ScheduleListCells['order']): string {
  switch (cell.status) {
    case 'stage': return cell.stage.label
    case 'none': return cell.slot === 'FOREMAN' ? LIST_FOREMAN_NONE_TEXT : cell.slot === 'SCHEDULE_ONLY' ? LIST_SCHEDULE_ONLY_TEXT : LIST_ORDER_NONE_TEXT
    case 'no-signal': return LANE_NO_SIGNAL_TEXT
    case 'unknown': return LANE_UNKNOWN_TEXT
    case 'order-error': return LIST_ORDER_ERROR_TEXT
  }
}

/** 칸 1개의 점 색 — 막대 칸이 아니면 해당 없음(회색) */
export function cellDotColor(cell: StageCell | ScheduleListCells['order']): SignalColor {
  return cell.status === 'stage' ? cell.stage.color : 'NONE'
}
